import React from "react";
import { CheckIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { volumes, images } from "../data/content";
export function VolumesSection() {
  return <section className="bg-cream px-4 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-323" data-mp="co9453jbn6j6">
      <div className="mx-auto max-w-4xl" data-id="element-324" data-mp="7pena74wzs1p">
        <h2 id="volumes-title" className="text-center font-serif text-3xl font-bold leading-tight text-ink sm:text-5xl" data-id="element-325" data-mp="7qhekg65fwi5">
          What's inside <em className="text-wine-700" data-id="element-326" data-mp="3g354fbc7dy1d">Biomechanics War Room™?</em>
        </h2>
        <div className="-mx-4 mt-6 sm:mx-auto sm:max-w-2xl" data-id="element-327" data-mp="3c57do42sb3vv">
          <img src={images.product} alt="All six volumes of Biomechanics War Room™" className="w-full" data-id="element-328" data-mp="3pvknyd35euod" />
        </div>

        <ol className="mt-8 space-y-5" data-id="element-329" data-mp="3l39jqy1dkmq0">
          {volumes.map(v => <li key={v.numeral} className="overflow-hidden rounded-3xl bg-white shadow-sm ring-1 ring-wine-100" data-id="element-330" data-mp="2xe87t0tc2tfz">
              <div className="flex items-center gap-4 bg-wine-900 px-5 py-4 sm:px-7" data-id="element-331" data-mp="2sgf2sb3ro5ha">
                <span className="font-serif text-4xl font-extrabold italic text-wine-300" data-id="element-332" data-mp="29g0jmetp7sot">{v.numeral}</span>
                <div data-id="element-333" data-mp="2edtkqtg59wi8">
                  <p className="text-xs font-bold uppercase tracking-wider text-wine-200" data-id="element-334" data-mp="2edack4gaqmhe">Volume {v.numeral}</p>
                  <h3 className="font-serif text-xl font-bold leading-tight text-white sm:text-2xl" data-id="element-335" data-mp="2j63k1035g8x6">{v.title}</h3>
                </div>
              </div>
              <div className="p-5 sm:p-7" data-id="element-336" data-mp="1qh5zsrfdo21s">
                <p className="text-[17px] font-semibold leading-snug text-ink" data-id="element-337" data-mp="1qih54voh1hv0">{v.subtitle}</p>
                <p className="mt-3 text-[16px] leading-relaxed text-ink-soft" data-id="element-338" data-mp="1vg960f73gebc">{v.intro}</p>
                {v.items.length > 0 && <ul className="mt-4 grid grid-cols-1 gap-x-6 gap-y-2.5 min-[400px]:grid-cols-2" data-id="element-339" data-mp="24gfhjvj8f47v">
                    {v.items.map(item => <li key={item} className="flex items-start gap-2 text-[15px] font-medium text-ink" data-id="element-340" data-mp="3bt7hmjzwxkyx">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-cta" strokeWidth={3} aria-hidden="true" data-id="element-341" data-mp="3fu9mbgclmp8a" />
                        {item}
                      </li>)}
                  </ul>}
                <p className="mt-5 border-l-4 border-wine-600 pl-4 text-[16px] font-medium italic leading-relaxed text-wine-900" data-id="element-342" data-mp="1bu2ha997p6e1">{v.closing}</p>
              </div>
            </li>)}
        </ol>

        <div className="mt-12" data-id="element-343" data-mp="1kql6baeboa5c">
          <CtaButton label="I want all 6 volumes" data-id="element-344" data-mp="x222p867wljl" />
        </div>
      </div>
    </section>;
}